/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "ec3f891e1a7cdf5371be539c7c138567d69d0a59";
